import Cadec from './Cadec';

export default Cadec;
